import { Phone } from 'lucide-react';

export const PromoBanner = () => (
  <div
    className="w-full bg-gradient-to-r from-orange-600 via-orange-500 to-orange-600 text-white px-4 py-2 text-xs sm:text-sm font-medium"
    data-testid="summer-promo-banner"
  >
    <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-center gap-x-2.5 gap-y-1 pl-12 sm:pl-0">
      <span className="inline-flex items-center">
        <span className="font-bold">Independent Pre-Purchase Vehicle Inspections</span>
        <span className="hidden md:inline">&nbsp;· Serving North Florida &amp; South Georgia</span>
      </span>
      <a
        href="tel:+13213003256"
        className="inline-flex items-center gap-1.5 font-bold underline underline-offset-2 decoration-white/60 hover:decoration-white transition-colors"
        data-testid="promo-call-link"
      >
        <Phone className="w-3.5 h-3.5" /> Call 321.300.3256
      </a>
    </div>
  </div>
);

export default PromoBanner;
